module.exports = __webpack_public_path__ + "static/media/buy0.61f0411c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/buy/buy0.png
// module id = 1647
// module chunks = 0